import { ChangeDetectionStrategy, Component, Input } from "@angular/core";


export type BvAvatarSize = "sm" | "md" | "lg" | "xl";

/**
 * Round avatar. Mirrors design-system.html .avatar.
 *
 *   <bv-avatar [src]="user.photo" [name]="user.name"></bv-avatar>
 *   <bv-avatar [name]="'Jeff Kelley'" size="lg"></bv-avatar>
 */
@Component({
    selector: "bv-avatar",
    templateUrl: "./avatar.component.html",
    styleUrls: ["./avatar.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: "bv-avatar",
        "[class.bv-avatar--sm]": 'size === "sm"',
        "[class.bv-avatar--md]": 'size === "md"',
        "[class.bv-avatar--lg]": 'size === "lg"',
        "[class.bv-avatar--xl]": 'size === "xl"',
    },
    imports: []
})
export class BvAvatarComponent {
  @Input() src?: string | null;
  @Input() name?: string | null;
  @Input() size: BvAvatarSize = "md";

  get initials(): string {
    if (!this.name) return "?";
    const parts = this.name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return (parts[0][0] || "?").toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
}
